import Icon from '../Icon.vue'

Icon.register({
  'senior': {
    width: 9,
    height: 12,
    paths: [
      {
        d: 'M3.816 2.038l2.897 2.7a.347.347 0 010 .49l-.49.49a.347.347 0 01-.492 0l-1.91-1.697-.7.865 2.082 2.018c.19.19.253.473.162.726L3.106 11.73a.346.346 0 01-.446.202l-.59-.298a.346.346 0 01-.2-.445l2.033-3.56-.66-.633-1.98 3.322a.347.347 0 01-.45.196l-.593-.322a.347.347 0 01-.196-.45L2.284 6l-.557-.485c-.244-.244-.283-.64-.065-.907 1.252-1.538 2.154-2.57 2.154-2.57zm3.077.267A1.35 1.35 0 114.985.395a1.35 1.35 0 011.908 1.91zm1.585 9.191a.347.347 0 01-.294.392l-.687.1a.347.347 0 01-.393-.295L6.423 7.02a.346.346 0 01.293-.39l.683-.099a.345.345 0 01.39.293l.036.245.195 1.317.458 3.11z'
      }
    ]
  }
})
